class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class HeaderPredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search]');
    this.loading = this.querySelector('.predictive-search__loading-state');
    this.status = this.querySelector('.predictive-search-status');

    if (!this.input) return;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300)
    );
  }

  onChange(event) {
    const query = event.target.value.trim();

    if (!query) {
      this.close();
      return;
    }

    this.fetchResults(query);
  }

  fetchResults(query) {
    this.open();
    this.loading.style.display = 'block';

    fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search`
    )
      .then((response) => response.json())
      .then((data) => {
        this.renderResults(data.resources.results);
      })
      .catch(() => {
        this.close();
      })
      .finally(() => {
        this.loading.style.display = 'none';
      });
  }

  renderResults(results) {
    const { products, collections, pages } = results;

    let html = '<ul class="predictive-search__results-list">';

    [...products, ...collections, ...pages].forEach((item) => {
      html += `
        <li class="predictive-search__list-item">
          <a href="${item.url}" class="predictive-search__item">
            ${
              item.image
                ? `<img src="${item.image}" alt="${item.title}" width="40" height="40">`
                : ''
            }
            <span class="predictive-search__item-heading">${item.title}</span>
          </a>
        </li>
      `;
    });

    html += '</ul>';

    this.results.innerHTML = html;
    this.status.textContent = `${products.length} results available`;
  }

  open() {
    this.results.classList.add('is-active');
    this.results.removeAttribute('tabindex');
  }

  close() {
    this.results.classList.remove('is-active');
    this.results.setAttribute('tabindex', '-1');
    this.results.innerHTML = '';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', HeaderPredictiveSearch);
